<template>
  <div class="aboutUs">
    <!-- 视频模态框 -->
    <div v-if="showVideoModal" class="video-modal" @click="closeVideo">
      <div class="video-modal-content" @click.stop>
        <div class="video-header">
          <span class="close-btn" @click="closeVideo">×</span>
        </div>
        <div class="video-container">
          <video 
            ref="videoPlayer" 
            controls 
            controlsList="nodownload" 
            oncontextmenu="return false;"
            autoplay 
            :src="videoSrc"
            class="video-player"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
      </div>
    </div>

    <vue-particles
      :particleOpacity="0.7"
      :particlesNumber="50"
      shapeType="circle"
      :particleSize="1"
      linesColor="#009FFF"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push">
    </vue-particles>
    <div class="about_middle">
      <div class="cirle_1"></div>
      <div class="cirle_2"></div>
      <div class="aboutUs_t">
        <div class="aboutUs_t_view">
          <div class="aboutUs_t_l">
            <div class="aboutUs_t_l_title">我们用AI<br>重新定义碳中和</div>
            <div class="aboutUs_t_l_content">当时代浪潮奔涌至气候与AI的交汇点，中碳普惠云科技已是坚定的探路者。我们以AI为火把，破开传统碳管理的重重迷雾，在前行的道路上刻下航迹，为行业铸就一座指向未来的灯塔</div>
          </div>
          <div class="aboutUs_t_r">
            <div class="aboutUs_t_l_swiper">
              <el-carousel :interval="3000" indicator-position="outside" arrow="never" trigger="click">
                <el-carousel-item v-for="item,index in list" :key="index">
                  <div class="aboutUs_t_l_swiper_item" :style="`background: url('${item.img}'); background-size: cover;`" @click="toDetail(item.url)">
                    <div class="aboutUs_t_l_swiper_item_content">{{ item.content }}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="aboutUs_b">
        <div class="mask">
          <div class="mask_view">
            <div class="mask_view_l" @click="toVideo">
              <div class="mask_view_l_view">查看视频</div>
            </div>
            <div class="mask_view_r">
              <div class="wechat-container" 
                   @mouseenter="weChatHover = true" 
                   @mouseleave="weChatHover = false">
                <div v-if="!weChatHover" class="mask_view_r_item">
                  <img class="icon_1" src="@/assets/img/home/weChat.png" alt="">
                  公众号
                </div>
                <img v-else class="icon_4" src="@/assets/img/home/weChat_img.png" alt="">
              </div>
              <div class="mask_view_r_item" @click="gotoDouyin">
                <svg class="icon_2" width="37" height="45" viewBox="0 0 37 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M36.948 18.6284C33.3056 18.6284 29.763 17.4287 26.8492 15.2095V30.6914C26.8492 38.5972 20.8393 45 13.4246 45C6.00984 45 0 38.5972 0 30.6914C0 22.7856 6.00984 16.3828 13.4246 16.3828C14.1661 16.3828 14.8859 16.4487 15.5883 16.5718V24.772C14.9162 24.5039 14.2008 24.3677 13.481 24.3677C10.1725 24.3677 7.48846 27.2241 7.48846 30.7529C7.48846 34.2773 10.1725 37.1382 13.481 37.1382C16.7851 37.1382 19.4691 34.2773 19.4691 30.7529V0H26.9576C26.9576 5.91064 31.4541 10.7007 37 10.7007V18.624L36.948 18.6284Z"/>
                </svg>
                抖音
              </div>
              <div class="mask_view_r_item" @click="gotoBilili">
                <svg class="icon_3" width="101" height="45" viewBox="0 0 101 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M78.0244 14.1779C78.2888 14.222 80.3594 13.7593 80.4475 13.9135C80.5797 14.1118 81.5049 20.7665 81.2626 20.8106C81.0203 20.8546 79.3021 21.2513 79.3021 21.2513C79.1699 20.3478 78.0465 14.7508 78.0244 14.1779ZM81.3287 13.5389L82.2318 20.7004C82.6944 20.6784 84.5668 20.5461 84.7431 20.5241C84.4787 17.8138 84.0161 13.5389 84.0161 13.5389C83.135 13.3626 82.2098 13.3626 81.3287 13.5389ZM79.5444 23.4768C79.5444 23.4768 83.6196 22.4412 85.0955 22.948C85.8445 25.6583 87.2103 40.8627 87.3424 41.4797C86.4172 41.5899 83.3773 41.8543 83.135 41.9204C82.9367 40.7746 79.5444 24.204 79.5444 23.4768ZM94.6338 14.3542C94.8761 14.4203 97.0349 14.1339 97.0569 14.2881C97.101 14.817 97.3213 21.2072 97.0789 21.2292C96.8366 21.2513 95.1184 21.4055 95.1184 21.4055C95.0744 20.5241 94.5898 14.9492 94.6338 14.3542ZM97.9601 14.1779L98.1363 21.2513C98.5989 21.2513 100.449 21.3614 100.648 21.3394C100.603 18.6291 100.648 14.3542 100.648 14.3542C99.7664 14.2 98.8632 14.1339 97.9601 14.1779ZM95.1184 23.6752C95.1184 23.6752 99.2818 23.1243 100.692 23.7853C101 26.9584 100.956 41.7441 101 42.3611C100.053 42.3611 97.0349 42.4052 96.7926 42.4493C96.7485 41.3034 95.0523 24.4023 95.1184 23.6752ZM85.448 5.496C87.8491 17.7477 89.6774 38.6812 89.7435 40.0254C89.7435 40.0254 91.638 40.0695 93.7747 40.2017C92.5191 27.0025 90.9771 5.91467 90.9991 5.23157C90.4704 4.63662 85.448 5.496 85.448 5.496ZM80.1612 34.4725C79.6986 31.035 67.4068 27.1347 60.4899 28.3907C60.4899 28.3907 59.6307 20.8106 59.3003 13.4728C59.014 7.17069 59.2563 1.04486 59.3224 0.0312315C58.8598 -0.299299 53.8813 2.08052 51.1939 3.07211C51.1939 3.07211 54.41 16.69 56.745 44.9393C56.745 44.9393 60.4678 45.3359 66.8561 44.1019C73.2443 42.8679 80.8 39.0118 80.1612 34.4725ZM65.1378 40.6644L64.0584 32.8859C64.3228 32.7537 70.9533 35.2217 71.6582 35.6624C71.5481 36.1472 65.1378 40.6644 65.1378 40.6644ZM26.8305 14.1779C27.0949 14.222 29.1655 13.7593 29.2537 13.9135C29.3858 14.1118 30.311 20.7665 30.0687 20.8106C29.8264 20.8546 28.1082 21.2513 28.1082 21.2513C27.976 20.3478 26.8526 14.7508 26.8305 14.1779ZM30.1348 13.5389L31.0379 20.7004C31.5005 20.6784 33.373 20.5461 33.5492 20.5241C33.2628 17.8138 32.8222 13.5389 32.8222 13.5389C31.9411 13.3626 31.0159 13.3626 30.1348 13.5389ZM28.3505 23.4768C28.3505 23.4768 32.4257 22.4412 33.9016 22.948C34.6506 25.6583 36.0164 40.8627 36.1485 41.4797C35.2233 41.5899 32.1834 41.8543 31.9411 41.9204C31.7429 40.7746 28.3505 24.204 28.3505 23.4768ZM43.4399 14.3542C43.6822 14.4203 45.841 14.1339 45.863 14.2881C45.9071 14.817 46.1274 21.2072 45.8851 21.2292C45.6427 21.2513 43.9245 21.4055 43.9245 21.4055C43.8805 20.5241 43.4179 14.9492 43.4399 14.3542ZM46.7662 14.1779L46.9424 21.2513C47.405 21.2513 49.2554 21.3614 49.4537 21.3394C49.4096 18.6291 49.4537 14.3542 49.4537 14.3542C48.5725 14.2 47.6694 14.1559 46.7662 14.1779ZM43.9245 23.6752C43.9245 23.6752 48.0879 23.1243 49.4977 23.7853C49.8061 26.9584 49.7621 41.7441 49.8061 42.3611C48.8589 42.3611 45.841 42.4052 45.5987 42.4493C45.5767 41.3034 43.8584 24.4023 43.9245 23.6752ZM34.2541 5.496C36.6552 17.7477 38.4835 38.6812 38.5496 40.0254C38.5496 40.0254 40.4441 40.0695 42.5808 40.2017C41.3252 27.0025 39.7832 5.91467 39.8052 5.20954C39.2766 4.63662 34.2541 5.496 34.2541 5.496ZM28.9673 34.4725C28.5047 31.035 16.2129 27.1347 9.29596 28.3907C9.29596 28.3907 8.43686 20.8106 8.10643 13.4728C7.82007 7.17069 8.06238 1.04486 8.12846 0.0312315C7.66587 -0.277263 2.68746 2.08052 0 3.07211C0 3.07211 3.21614 16.69 5.55115 44.9393C5.55115 44.9393 9.27394 45.3359 15.6622 44.1019C22.0504 42.8679 29.6061 39.0118 28.9673 34.4725ZM13.9439 40.6644L12.8646 32.8859C13.1289 32.7537 19.7594 35.2217 20.4643 35.6624C20.3542 36.1472 13.9439 40.6644 13.9439 40.6644Z"/>
                </svg>
                哔哩哔哩
              </div>
            </div>
          </div>
        </div>
        <div class="aboutUs_b_view">
          <div class="aboutUs_b_view_t">
            <div 
              v-for="(item, index) in switchData" 
              :key="index"
              class="aboutUs_b_view_t_item"
              :class="{ active: currentIndex === index }"
            >
              <div class="aboutUs_b_view_t_item_title">{{ item.topTitle }}</div>
              <div class="aboutUs_b_view_t_item_content">{{ item.topContent }}</div>
            </div>
          </div>
          <div class="aboutUs_b_view_b">
            <div v-html="switchData[currentIndex].bottomContent"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer pageType="about"/>
  </div>
</template>

<script>
import Footer from '@/components/footer/index.vue'
export default {
  components: {
    Footer
  },
  data() {
    return {
      chooseIndex: 0,
      list:[{
        img: require('@/assets/img/home/swiper_1.png'),
        content: '碳索之路 ｜ 碳管理进入Agent时代！中碳普惠云碳盘Agent登陆腾讯云云市场',
        url: 'https://mp.weixin.qq.com/s/MLGhb5xQ-_BuH2-assGLBg',
      },{
        img: require('@/assets/img/home/swiper_2.png'),
        content: '碳索之路 ｜ 碳管理进入Agent时代！中碳普惠云碳盘Agent登陆百度云云市场',
        url: 'https://mp.weixin.qq.com/s?__biz=MzkxODUyMDc5OQ==&mid=2247487233&idx=1&sn=5cf90102021a67857dab7e5d8c978aa8&scene=21&poc_token=HD6oHmmjNSWz79ix5XgWgNZx3GvLYqSO-OVKc6BD',
      },{
        img: require('@/assets/img/home/swiper_3.png'),
        content: '碳索之路 ｜ 碳管理进入Agent时代！中碳普惠云碳盘Agent登陆阿里云云市场',
        url: 'https://mp.weixin.qq.com/s?__biz=MzkxODUyMDc5OQ==&mid=2247487288&idx=1&sn=76e2847da1e58d40ba4c5e423e824cea&chksm=c1b15988f6c6d09e6b6c1eff1dbd51b07ddf8775668ec6e14a0c3524d538be8b2d59c93efd3a&cur_album_id=4180934045142089733&scene=189#wechat_redirect',
      },{
        img: require('@/assets/img/home/swiper_4.png'),
        content: '碳索之路 ｜ 中碳普惠云携AI黑科技冲刺中国创新创业大赛',
        url: 'https://mp.weixin.qq.com/s?__biz=MzkxODUyMDc5OQ==&mid=2247487159&idx=1&sn=51cf411ab944f2a3b13965f217b70949&chksm=c1b15807f6c6d111304e49c7b03a2ead9667eeeba83f91c859768d35b50fde20ed4ae9d0c44c&cur_album_id=4180934045142089733&scene=190#rd',
      }],
      currentIndex: 0,
      switchData: [
        {
          topTitle: "Discover the Future",
          topContent: "发现未来",
          bottomContent: "中碳普惠云科技有限公司<br>是由具有海内外前沿科技创新和行业洞察力的北清创始团队联手央企、国内算力独角兽共同发起<br>是一家聚焦于碳中和领域的大模型及AI Agent应用的科技型企业"
        },
        {
          topTitle: "Embrace the Future",
          topContent: "拥抱未来",
          bottomContent: "3060中国承诺打开万亿级市场<br>AI Agent具备极强的模型推理和算法优化的优势<br>我们相信通过让每次碳管理决策都被赋予AI能量<br>能够利用前沿科技解决气候危机引发的挑战"
        },
        {
          topTitle: "Transform the Future",
          topContent: "改变未来",
          bottomContent: "我们致力于成为碳中和领域的AI探索者<br>通过技术创新重构产业低碳生态<br>让每个组织都能以AI驱动的方式参与气候行动"
        }
      ],
      weChatHover: false,
      showVideoModal: false,
      videoSrc: require('@/assets/img/home/openWin.mp4'),
    }
  },
  mounted() {
    // 启动定时器，每3秒切换一次
    this.startAutoSwitch();
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    startAutoSwitch() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.switchData.length;
      }, 3000);
    },

    toDetail(url){
      window.open(url, '_blank')
    },

    toVideo(){
      this.showVideoModal = true;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play().catch(error => {
            console.log('视频自动播放失败:', error);
          });
        }
      });
    },

    closeVideo() {
      this.showVideoModal = false;
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
    },

    handleKeydown(event) {
      if (event.key === 'Escape' && this.showVideoModal) {
        this.closeVideo();
      }
    },

    gotoBilili(){
      window.open('https://space.bilibili.com/3546913903217483?spm_id_from=333.788.upinfo.head.click', '_blank')
    },

    gotoDouyin(){
      window.open('https://v.douyin.com/a4DWyxMm2Yw/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.aboutUs{
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;

  .video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .video-modal-content {
      background: #fff;
      border-radius: 12px;
      width: 80%;
      max-width: 900px;
      max-height: 80vh;
      overflow: hidden;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

      .video-header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        // padding: 20px;
        background: linear-gradient(360deg, #64C5FF 0%, #117FDB 100%);
        color: white;

        .close-btn {
          font-size: 30px;
          cursor: pointer;
          padding: 5px 10px;
          border-radius: 50%;
          transition: background 0.3s;
        }
      }

      .video-container {
        padding: 20px;

        .video-player {
          width: 100%;
          height: auto;
          max-height: 60vh;
          border-radius: 8px;
          outline: none;
        }
      }
    }
  }

  .vue-particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .about_middle{
    // position: absolute;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;

    .cirle_1{
      position: absolute;
      background: rgba(0, 159, 255, 0.31);
      backdrop-filter: blur(580px);
      box-shadow: 0 0 800px 250px rgba(0, 159, 255, 0.12);
      left:300px;
      top: 250px;
    }

    .cirle_2{
      position: absolute;
      background: rgba(0, 159, 255, 0.32);
      backdrop-filter: blur(580px);
      box-shadow: 0 0 800px 350px rgba(0, 159, 255, 0.22);
      right:300px;
      top: 550px;
      motion-rotation: -150deg;
    }

    .aboutUs_t{
      width: calc(100vw - (100vw * 288 / 1920));
      height: calc(100vh * 770 / 1080);
      display: flex;
      justify-content: center;

      .aboutUs_t_view{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: start;
        margin-top: calc(100vh * 263 / 1080);

        .aboutUs_t_l{
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          
          
          .aboutUs_t_l_title{
            font-size: 88px;
            font-weight: 700;
            color: #000;
            letter-spacing: 2px;
            line-height: 110%;
          }

          .aboutUs_t_l_content{
            font-size: 28px;
            font-weight: 300;
            color: #000;
            margin-top:75px;
            line-height: 48px;
            padding-left:13px;
            border-left: 5px solid rgba(58, 161, 237, 1);
          }

        }

        .aboutUs_t_r{
          width: 35%;
          height: 100%;
          display: flex;
          justify-content: end;
          // align-items: center;
          // margin-top: calc(100vh * 88 / 1080);

          .aboutUs_t_l_swiper{
            width: calc(100vw * 690 / 1920);
            height: calc(100vh * 425 / 1080);
            // border-radius: 20px;
            // box-shadow: 0px 8px 5px 0px rgba(0, 0, 0, 0.25);

            ::v-deep .el-carousel{
              // border-radius: 20px;
            }

            ::v-deep .el-carousel__container{
              border-radius: 20px;
              width: calc(100vw * 690 / 1920);
              height: calc(100vh * 375 / 1080);
            }

            ::v-deep .el-carousel__item{
              border-radius: 20px;
              width: calc(100vw * 690 / 1920);
              height: calc(100vh * 375 / 1080);
            }

            ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
                width: 18px;
                height: 18px;
                background: rgba(58, 161, 237, 0.25);
                border-radius: 50%;
                opacity: 1;
            }
            
            ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
                width: 18px;
                height: 18px;
                background: rgba(58, 161, 237, 1);
                border-radius: 50%;
                opacity: 1;
            }

            .aboutUs_t_l_swiper_item{
              width: 100%;
              height: 100%;
              position: relative;

              .aboutUs_t_l_swiper_item_content{
                position: absolute;
                bottom: calc(100vh * 25 / 1080);
                left: 0;
                font-size: 24px;
                font-weight: 500;
                line-height: 28px;
                color: #fff;
                padding: 0 35px;
              }
            }
          }
        }
      }
    }

    .aboutUs_b{
      width: 100%;
      height: calc(100vh * 1053 / 1080);
      background: url('../../assets/img/home/aboutUs_img.png') no-repeat center center / 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: calc(100vh * 20 / 1080);

      .mask{
        width: 100%;
        height: calc(100vh * 288 / 1080);
        background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);

        .mask_view{
          margin: 0 calc(100vw * 130 /1920);
          width: calc(100vw - (100vw * 355 / 1920));
          height: calc(100vh * 48 / 1080);
          display: flex;
          justify-content: space-between;
          // justify-content: flex-end;
          align-items: center;

          .mask_view_l{
            width: 250px;
            height: 65px;
            border-radius: 100px;
            background: linear-gradient(180deg, #FFFFFF 0%, #305B7B 50%, #0281DF 100%);
            box-shadow: 0px 10px 20px 0px rgba(24, 133, 213, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            font-weight: 700;
            color: rgba(33, 80, 114, 1);
            cursor: pointer;

            .mask_view_l_view{
              background: linear-gradient(180deg, #CBE9FF 0%, #588CB2 100%);
              width: 244px;
              height: 59px;
              border-radius: 100px;
              display: flex;
              justify-content: center;
              align-items: center;

              &:hover{
                box-shadow: 
                  0px 10px 20px 0px rgba(31, 133, 208, 0.5),
                  0px 0px 60.3px 0px rgba(0, 50, 31, 1) inset;
                background: linear-gradient(180deg, #CBE9FF 0%, #004171 100%);
                color:#fff;
              }
            }

            .mask_view_l_icon{
              width:16px;
              height: 16px;
            }
          }

          .mask_view_r{
            display: flex;
            align-items: center;

            .wechat-container {
              position: relative;
              display: inline-block;
              margin-left: 40px; // 保持与其他元素相同的间距
              
              .mask_view_r_item {
                cursor: pointer;
                transition: all 0.3s ease;
                margin-left: 0; // 移除内部间距
              }
              
              .icon_4 {
                cursor: pointer;
                transition: all 0.3s ease;
                margin-left: 0; // 移除负边距，避免重叠
              }
            }

            .mask_view_r_item{
              font-size: 28px;
              font-weight: 300;
              color: rgba(113, 113, 113, 1);
              cursor: pointer;
              margin-left:40px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover{
                color: rgba(0, 0, 0, 1);
                font-weight: 500;

                .icon_2{
                  fill: rgba(0, 0, 0, 1);
                }

                .icon_3{
                  fill: rgba(239, 128, 152, 1);
                }
              }

              .icon_1{
                width:47px;
                height:44px;
                margin-right:12px;
              }

              .icon_2{
                width:37px;
                height:44px;
                margin-right:12px;
                fill: rgba(113, 113, 113, 1);
              }

              .icon_3{
                width:101px;
                height:45px;
                margin-right:12px;
                fill: rgba(113, 113, 113, 1);
              }
            }

            .icon_4{
              width: 155px;
              height: 200px;
            }
          }
        }
      }

      .aboutUs_b_view{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: start;
        align-items: center;
        flex-direction: column;
        margin-top: 100px;

        .aboutUs_b_view_t{
          display: flex;
          align-items: center;
          justify-content: center;

          .aboutUs_b_view_t_item{
            display: block; 
            text-align: center;
            width: calc(100vw * 315 / 1920);
            color: rgba(0, 0, 0, 0.5);
            position: relative;

            .aboutUs_b_view_t_item_title{
              font-size: 32px;
              font-weight: 300;
              transition: all 0.3s ease;
            }

            .aboutUs_b_view_t_item_content{
              font-size: 64px;
              font-weight: 700;
              transition: all 0.3s ease;
            }

            &.active{
              .aboutUs_b_view_t_item_title{
                color: rgba(17, 127, 219, 1);
              }

              .aboutUs_b_view_t_item_content{
                color: rgba(0, 0, 0, 1);
              }

              &::after{
                position: absolute;
                content: '';
                width: 250px;
                height: 5px;
                background: rgba(17, 127, 219, 1);
                bottom: -20px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
          }
        }

        .aboutUs_b_view_b{
          text-align: center;
          margin-top:45px;
          
          div{
            font-size: 32px;
            font-weight: 300;
            color: #333;
          }
        }
      }
    }
  }
}
</style>